import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Box,
  HStack,
  Image,
  Text,
  VStack,
  useMediaQuery,
  Pressable,
  Spinner,
} from "native-base";
import CryptoJS from "crypto-js";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import { COLORS } from "../../utils/colors";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import {
  deletePackagesAPI,
  getPackagesAPI,
} from "../../api/apis/vendor";
import { Toaster } from "../../components/toaster";
import "./style.css";
import { LoaderAnimation } from "../../components/spinner";
import { Link } from "react-router-dom";
import CustomButton from "../../components/button";
import {
  activeEventTab,
  activePackagesTab,
} from "../../store/reducers/eventSlice";
import NoDataFound from "../../components/noDataFound";
import config from "../../utils/config";

export const PackagesCard = forwardRef(
  (
    {
      handleEditPackage = () => {},
      activeButton = "pending",
      landingPage = false,
      selectedAgency = "",
      getPackagesCount = () => {},
      setFilterOptions = () => {},
      filterOptions = {},
    },
    ref
  ) => {
    const toaster = Toaster();
    const dispatch = useDispatch();
    const [packageDetails, setPackageDetails] = useState([]);
    const [packageAgency, setPackageAgency] = useState([]);
    const [MobileWindow] = useMediaQuery({
      maxWidth: MOBILE_VIEW_WIDTH,
    });
    const [isLoading, setIsLoading] = useState(true);
    const [isImageLoading, setIsImageLoading] = useState(true);

    const handleOnLoad = () => {
      setIsImageLoading(false);
    };

    useEffect(() => {
      setPackageDetails([]);
      getPackagesListing();
    }, [activeButton, selectedAgency]);

    const getPackagesListing = async () => {
      setIsLoading(true);
      let res = await getPackagesAPI(1, 10000, activeButton, selectedAgency);
      if (res.error) {
        toaster(res.message, "error", "error");
        return;
      } else if (Object.keys(res.data?.data?.data).length > 0) {
        getPackagesCount(true);
        setPackageDetails(res.data?.data?.data?.[0]?.list_of_packages);
        setPackageAgency(res.data?.data?.data?.[0]?.list_of_agency_name.sort());
      }
      setIsLoading(false);
    };

    const handleAgencyName = () => {
      return packageAgency;
    };

    useImperativeHandle(ref, () => ({
      getPackagesListing,
      handleAgencyName,
    }));

    const handleAction = async (ind, action_name) => {
      if (action_name === "edit") {
        handleEditPackage(packageDetails[ind]);
      } else if (action_name === "delete") {
        LoaderAnimation.show();
        let payload = {
          package_ids: [
            {
              package_id: packageDetails[ind]._id,
            },
          ],
        };
        let res = await deletePackagesAPI(payload);
        if (res.error) {
          toaster(res.message, "error", "error");
          LoaderAnimation.hide();
          return;
        } else {
          toaster("Package Deleted Successfully", "success", "success");
          getPackagesListing();
        }
      }
    };

    return (
      <>
        {isLoading ? (
          <Box
            mt={5}
            mb={10}
            flex={1}
            alignItems="center"
            justifyContent="center"
          >
            <Spinner color={COLORS.THEME_COLOR} size="lg" />
          </Box>
        ) : (
          <VStack alignItems={landingPage && "center"} w={"100%"}>
            {packageDetails.length > 0 ? (
              <>
                <HStack
                  justifyContent={landingPage && "center"}
                  direction={MobileWindow ? "column" : "row"}
                  flexWrap={"wrap"}
                  width={(MobileWindow || landingPage) && "100%"}
                >
                  {packageDetails
                    .map((item, ind) => {
                      return (
                        <Box
                          width={
                            MobileWindow
                              ? "100%"
                              : landingPage
                              ? "396px"
                              : "calc(100% / 4.2)"
                          }
                          style={{
                            boxShadow:
                              "0px 18.953px 47.382px 0px rgba(119, 115, 170, 0.10)",
                            borderRadius: "8px",
                          }}
                          bg={COLORS.WHITE_COLOR}
                          mr={"1%"}
                          mb={"24px"}
                          position={"relative"}
                        >
                          <Link
                            style={{ textDecoration: "none" }}
                            to={
                              landingPage
                                ? "/package-detail"
                                : "/packages-detail"
                            }
                          >
                            <Pressable
                              onPress={() => {
                                sessionStorage.setItem(
                                  "package",
                                  CryptoJS.AES.encrypt(
                                    JSON.stringify(item),
                                    config.packageKey
                                  ).toString()
                                );
                              }}
                            >
                              <Box
                                width={
                                  MobileWindow
                                    ? "100%"
                                    : !landingPage
                                    ? "100%"
                                    : "396px"
                                }
                                // maxW={MobileWindow ? "100%" : "396px"}
                                style={{
                                  boxShadow:
                                    "0px 18.953px 47.382px 0px rgba(119, 115, 170, 0.10)",
                                  borderRadius: "8px",
                                }}
                                bg={COLORS.WHITE_COLOR}
                                mr={"24px"}
                                // mb={"24px"}
                                position={"relative"}
                              >
                                <Box
                                  width={"100%"}
                                  height={"182px"}
                                  borderRadius={"8px"}
                                >
                                  {/* {isImageLoading && (
                                    <p style={{ margin: "auto" }}>Loading...</p>
                                  )} */}
                                  <Image
                                    source={{
                                      uri: item?.banner_image[0]?.file_name?.includes(
                                        "https://"
                                      )
                                        ? item?.banner_image[0]?.file_name
                                        : config.bucketPath +
                                          item?.banner_image[0]?.file_name,
                                    }}
                                    alt="image"
                                    width={"100%"}
                                    height={"100%"}
                                    borderTopRadius={"8px"}
                                    resizeMode="stretch"
                                    onLoad={handleOnLoad}
                                  />
                                </Box>
                                <Box my={"12px"} mx={"16px"}>
                                  <Text
                                    fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                                    fontWeight={
                                      COMMONFONTWEIGHT.MEDIUM_LARGE_FONT_WEIGHT
                                    }
                                  >
                                    {item.package_name}
                                  </Text>
                                </Box>
                              </Box>
                            </Pressable>
                          </Link>
                        </Box>
                      );
                    })
                    .slice(0, landingPage ? 3 : undefined)}
                </HStack>
                {landingPage && packageDetails.length > 3 && (
                  <CustomButton
                    mt="3"
                    onPress={() => {
                      dispatch(activeEventTab("packages"));
                      dispatch(activePackagesTab("Ongoing package"));
                    }}
                    isOutline
                    textColor={COLORS.BLACK_COLOR}
                    bgColor={COLORS.BLACK_COLOR}
                    text="View All"
                    width="fit-content"
                    py="10px"
                  />
                )}
              </>
            ) : (
              <NoDataFound
                dataName="package"
                events={landingPage ? true : false}
              />
            )}
          </VStack>
        )}
      </>
    );
  }
);
